import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders } from '../../../../../Containers/Config/index.js';
import { LIST_EXPENDITURE_RULE, LIST_EXPENDITURE_RULE_SUCCESS, LIST_EXPENDITURE_RULE_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';
import { Constant } from '../../../../../Containers/Helpers/constant.js';

function* getExpenditureRulesList({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${baseUrl}/admin/rules`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
    });

    if (response.status === 200) {
      yield put({
        type: LIST_EXPENDITURE_RULE_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: LIST_EXPENDITURE_RULE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: LIST_EXPENDITURE_RULE_ERROR, payload: error });
  }
}

export function* watchExpenditureRules() {
  yield takeEvery(LIST_EXPENDITURE_RULE, getExpenditureRulesList);
}

function* expenditureRulesListSaga() {
  yield all([fork(watchExpenditureRules)]);
}

export default expenditureRulesListSaga;
